const OPEN_MODAL_SELECTOR = [
  '[role="dialog"][data-state="open"]',
  '[role="alertdialog"][data-state="open"]',
].join(", ");

/** Matches AppModal / Radix dialog exit animation (`duration-200`) with buffer. */
export const MODAL_EXIT_ANIMATION_MS = 300;

export function hasOpenModalInDom(): boolean {
  if (typeof document === "undefined") {
    return false;
  }

  return document.querySelector(OPEN_MODAL_SELECTOR) != null;
}

/**
 * Resets scroll lock / pointer-events / aria-hidden side effects that Radix Dialog
 * can leave behind when a modal unmounts before its close animation finishes.
 */
export function cleanupOrphanedModalSideEffects(): void {
  if (typeof document === "undefined") {
    return;
  }

  const body = document.querySelector("body");
  const documentElement = document.querySelector("html");

  if (!body || !documentElement || hasOpenModalInDom()) {
    return;
  }

  body.style.removeProperty("pointer-events");
  body.style.removeProperty("overflow");
  body.style.removeProperty("padding-right");
  documentElement.style.removeProperty("overflow");
  body.removeAttribute("data-scroll-locked");

  for (const child of Array.from(body.children)) {
    if (!(child instanceof HTMLElement)) {
      continue;
    }

    if (child.getAttribute("aria-hidden") === "true") {
      child.removeAttribute("aria-hidden");
      child.removeAttribute("data-aria-hidden");
    }
  }
}
